// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  alertId: __t.u64().primaryKey().name("alert_id"),
  workspaceId: __t.u64().name("workspace_id"),
  kind: __t.string(),
  summary: __t.string(),
  evidenceRefsJson: __t.string().name("evidence_refs_json"),
  status: __t.string(),
  createdAt: __t.i64().name("created_at"),
  resolvedAt: __t.option(__t.i64()).name("resolved_at"),
});
